module.exports = __webpack_public_path__ + "static/media/view3.83e98f7d.jpg";